<template>
  <div class="overlay">
    <div
      v-click-outside="
        () => {
          $emit('close');
        }
      "
      class="file-selector"
    >
      <div @click="$emit('close')" class="close-holder">
        <Icon icon="icon-park-outline:close" class="close-icon" />
      </div>

      <RepoContainer
        v-if="!hasRequestRepo"
        @file-selected="$emit('file-selected', $event)"
        @filterTable="fetchRepo()"
        @local-refresh="fetchRepo()"
        @refresh="fetchRepo()"
        :data="repoData"
        :search-data="repoSearchData"
        :search-mode="isRepoSearchMode"
        :total-count="repoTotalCount"
        select-mode
      />

      <div v-else class="loading-container">
        <Icon icon="line-md:loading-twotone-loop" class="loading-icon" />
      </div>
    </div>
  </div>
</template>

<script>
import { Icon } from "@iconify/vue2";
import vClickOutside from "v-click-outside";

import RepoContainer from "@/views/Internal Admin/components/tables/RepoContainer.vue";

export default {
  directives: {
    clickOutside: vClickOutside.directive,
  },

  components: {
    Icon,

    RepoContainer,
  },

  data() {
    return {
      hasRequestRepo: false,
      isRepoSearchMode: false,

      repoData: null,
      repoSearchData: null,

      repoTotalCount: 0,
    };
  },

  created() {
    this.$store.dispatch("admin/setRepoSelectedPath", null);
    this.$store.dispatch("admin/clearFilters");

    this.fetchRepo();
  },

  methods: {
    fetchRepo() {
      this.hasRequestRepo = true;

      const storeFilters = this.$store.getters["admin/getRepoFilters"];

      const queryParams = [...storeFilters, { query: "workflow_id", param: this.$service.getWorkflowId() }];

      this.$store
        .dispatch("admin/fetchRepo", this.$service.formatQueryParam(queryParams))
        .then((response) => {
          this.isRepoSearchMode = response.search_mode;

          if (response.search_mode) {
            this.repoSearchData = response.data;
          } else {
            this.repoData = response.data;
            this.repoSearchData = null;
          }

          this.repoTotalCount = response.total_count;
        })
        .finally(() => {
          this.hasRequestRepo = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.overlay {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  height: 100vh;
  width: 100vw;
  top: 0;
  left: 0;
  z-index: 99999999999;
  background: rgba(0, 0, 0, 0.5);

  .close-holder {
    margin-left: auto;
    padding: 5px 12px;

    .close-icon {
      font-size: 30px;
      min-height: 30px;
      min-width: 30px;
      color: #000000;
      cursor: pointer;
    }
  }

  .file-selector {
    display: flex;
    flex-direction: column;
    height: 85%;
    width: 75%;
    padding: 1rem;
    gap: 1rem;
    border-radius: 8px;
    border: 1px dashed #046af3;
    background: rgba(255, 255, 255, 0.8);

    .loading-container {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
      width: 100%;

      .loading-icon {
        font-size: 3rem;
        color: #046af3;
      }
    }
  }
}

@media (max-width: 800px) {
  .overlay {
    .file-selector {
      height: 100%;
      width: 100%;
      border-radius: 0;
    }
  }
}
</style>
